import React, {Component, PropTypes} from 'react';
import {List, ListItem} from 'material-ui/List';
import ThreeDotsMenu from './Menus/ThreeDotsMenu.jsx';
import ForwardButton from './Buttons/ForwardButton.jsx';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RetIvaCard from './RetIvaCard.jsx';
import Card from 'material-ui/Card';
import Mail from 'material-ui/svg-icons/content/mail';
import validator from 'validator';


class DataList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            itemHovered: null,
            modalOpen: false,
            deleting: null, 
        };

        this.handleItemHover = this.handleItemHover.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
    }

    /**
     * When the user hovers (or touches) the list item the ThreeDotsMenu becomes
     * visible for that list item
     * 
     * @param item Integer: The unique key of the list item
     */
    handleItemHover(item) {
        this.setState({itemHovered: item});
    }

    /**
     * Handles modal closing, if del is set to true performs the deletion
     * of the record with index this.state.deleting
     * 
     * @param del Boolean: Wether to delete or not the current list item
     */
    handleCloseModal(del) {
        if (del === true) this.props.handleDelete(this.state.deleting);

        this.setState({modalOpen: false, itemHovered: null});
    }

    /**
     * Opens the modal and set's the clicked item as the item being asked for
     * deletion
     * 
     * @param index Integer: The item of the record to be deleted
     */
    handleOpenModal(index) {
        this.setState({modalOpen: true, deleting: index});
    }

    render() {
        //Posible actions of the modal
        const actions = [
            <FlatButton
                label="Cancelar"
                primary={true}
                onTouchTap={this.handleCloseModal}
            />,
            <FlatButton
                label="Eliminar"
                primary={true}
                onTouchTap={this.handleCloseModal.bind(this, true)}
            />,
        ];

        const iconStyle = {
            position:'absolute',
            top:'0px',
            right:'4px',
        };

        //Iterate through supplied items and attach either a menu or a forward button depending
        //on the desired action
        let Items = this.props.items.map((item, index) => {
            let pText = this.props.useCard ? null : item.primaryText,
                sText = this.props.useCard ? null : item.secondaryText;
            //Create Items to be displayed on the ThreeDotsMenu
            let download = {};
            let sendMail = {};
            if (this.props.download) {
                download = {
                    primaryText: "Descargar",
                    onTouchTap: this.props.handleDownload.bind(this, index),
                    primary: true,
                    style:{marginRight:0}
                };
            }

            if (this.props.sendMail) {
                sendMail = {
                    primaryText: "Enviar",
                    onTouchTap: this.props.handleSend.bind(this, index),
                    disabled: !validator.isEmail(item.proveedor.email),
                    primary: true,
                    icon: <Mail />,
                    style:{marginRight:0}
                };
            }
            const menuItems = [
                {
                    ...download
                },
                
                {
                    primaryText: "Editar",
                    onTouchTap: this.props.handleEdit.bind(this, index),
                    style:{marginRight:0}
                },
                {
                    primaryText: "Eliminar",
                    onTouchTap: this.handleOpenModal.bind(this, index),
                    secondary: true
                },
                {
                    ...sendMail
                },
            ];  

            //Create the ThreeDotsMenu
            const Menu = (
                <ThreeDotsMenu 
                    menuProps={{style:iconStyle}} 
                    menuItems={menuItems}/>
                );

            //Create the Forward Button
            const Forward = (
                <ForwardButton 
                    iconButtonProps={{style:iconStyle}} 
                    onTouchTap={this.props.handleSelect ? this.props.handleSelect.bind(this, index) : null} />
            );

            const rightButton = (
                this.props.useCard ? null :
                this.props.rightButtonUseThis === true
                ? Forward
                : Menu
            );

            let CardData = null;
            let innerDivStyle = null;
            let LI = null;
            if (this.props.useCard) {
                let cardStyle = null;
                if (item.duplicate) cardStyle={background:'pink'};
                innerDivStyle = {padding: '5px 5px 5px 5px'};
                CardData = <RetIvaCard style={cardStyle} key={item.id} item={item} actions={menuItems} />;
                LI = (props) => <div key={item.id}>{props.children}</div>;
                
            } else {
                LI = (props) => (
                    <Card key={item.id} style={{marginBottom:8}}>
                        {props.children}
                    </Card>
                );
                
            }

            
        
            return (
                <LI key={item.id}>
                <ListItem
                    disableTouchRipple={true}
                    children={CardData}
                    innerDivStyle={innerDivStyle}
                    key={item.id}
                    rightIconButton={rightButton}
                    primaryText={pText}
                    secondaryText={sText}
                    />
                </LI>
            );
        });
        
        //Return value of render()
        return (
            <div>
                <List>
                {this.props.count > 0 ? Items : 
                   <p className="center">Usted no ha creado un(a) {this.props.resourceName} aún
                    </p>}
                    </List>

                <Dialog
                title="¿Desea Eliminar Este Registro?"
                actions={actions}
                modal={true}
                open={this.state.modalOpen}
                />
            </div>
            );
    }
}

DataList.propTypes = {
    handleDelete: PropTypes.func,
    handleEdit: PropTypes.func,
    items: PropTypes.array,
    rightButtonUseThis: PropTypes.bool,
    retencion: PropTypes.bool,
    resourceName: PropTypes.string.isRequired,
};

export default DataList;


/** WEBPACK FOOTER **
 ** ./app-react/components/DataList.jsx
 **/